const validation = {
  location: {
    presence: {
      message: '^validation.required'
    }
  },
};

export default validation;
